import type { ProductLogoMediumProps } from "../types";

/**
 * 中サイズのDevicesロゴアイコン
 */
export function ProductLogoMediumDevices({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <rect width="40" height="40" rx="5.88235" fill="#1A2142" />
      <path
        fill="#FCFCFD"
        d="M8.57059 12.857C8.57059 12.0681 9.21018 11.4285 9.99916 11.4285H28.5706C29.3596 11.4285 29.9992 12.0681 29.9992 12.857H8.57059Z"
      />
      <path
        fill="#FCFCFD"
        d="M28.5706 12.857H29.9992V13.8094C29.9992 14.0724 29.786 14.2856 29.523 14.2856H29.0468C28.7838 14.2856 28.5706 14.0724 28.5706 13.8094V12.857Z"
      />
      <path
        fill="#FCFCFD"
        d="M8.57059 12.857H9.99916V23.5713H8.57059V12.857Z"
      />
      <path
        fill="#FCFCFD"
        d="M8.57059 23.5713H21.6658C21.9288 23.5713 22.142 23.7845 22.142 24.0475V26.4285H8.57059V23.5713Z"
      />
      <path
        fill="#57D7D9"
        d="M21.6658 27.857C21.9288 27.857 22.142 27.6438 22.142 27.3808V24.9999H20.7134V25.7142C20.7134 26.1087 20.3937 26.4285 19.9992 26.4285H18.5706C18.1761 26.4285 17.8563 26.1087 17.8563 25.7142V24.9999H6.99916C6.68357 24.9999 6.42773 25.2557 6.42773 25.5713C6.42773 26.8337 7.45108 27.857 8.71345 27.857H21.6658Z"
      />
      <path
        fill="#FCFCFD"
        d="M23.5706 17.1428C23.5706 16.3538 24.2102 15.7142 24.9992 15.7142H30.7134C31.5024 15.7142 32.142 16.3538 32.142 17.1428V29.2856C32.142 30.0746 31.5024 30.7142 30.7134 30.7142H24.9992C24.2102 30.7142 23.5706 30.0746 23.5706 29.2856V17.1428Z"
      />
      <path
        fill="#57D7D9"
        d="M24.9992 17.857C24.9992 17.4625 25.319 17.1428 25.7134 17.1428H29.9992C30.3937 17.1428 30.7134 17.4625 30.7134 17.857V27.1428C30.7134 27.5372 30.3937 27.857 29.9992 27.857H25.7134C25.319 27.857 24.9992 27.5372 24.9992 27.1428V17.857Z"
      />
    </svg>
  );
}
